import { NextSeo } from 'next-seo'
import { Header } from '@components/Header'
import { Footer } from '@components/Footer'

export default function Terms() {
  return (
    <>
      <NextSeo
        title="Terms of Service"
        description="Majordomo Terms of Service"
      />
      <Header />

      <main className="pt-8 px-0 container mx-auto">
        <div className="max-w-5xl mx-auto">
          <div className="space-y-8 pt-12 md:pb-36 pb-12">
            <h4 className="font-black">Terms and Conditions</h4>

            <p>
              Agreement between User and{' '}
              <a
                className="text-accentBlue font-black hover:underline"
                href="https://www.majordomo.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.majordomo.com
              </a>
            </p>

            <p>
              Welcome to{' '}
              <a
                className="text-accentBlue font-black hover:underline"
                href="https://www.majordomo.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.majordomo.com
              </a>
              . The{' '}
              <a
                className="text-accentBlue font-black hover:underline"
                href="https://www.majordomo.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.majordomo.com
              </a>{' '}
              website and associated apps (collectively, the "Site") are
              comprised of various web pages and services operated by Majordomo
              LLC ("Majordomo"). The Site is offered to you conditioned on your
              acceptance without modification of the terms, conditions, and
              notices contained herein (the "Terms"). Your use of the Site
              constitutes your agreement to these Terms.
            </p>

            <h4 className="font-black">
              Please read these Terms carefully before you use the Site. By
              using Site, you, on behalf of yourself and any entity you
              represent, if applicable, acknowledge that you have read and
              understand these Terms, you agree to be bound by these Terms, and
              these Terms form a legally binding agreement between you and
              Majordomo. When taking certain actions on the Site, you may also
              be required to click-to-agree to these Terms. If acting on behalf
              of an entity, you must have, and you represent and warrant that
              you have, full authority to bind your entity to these Terms. These
              Terms apply to your use of the Site, and, unless otherwise
              expressly stated, these Terms do not apply to any of our offline
              transactions with you, if any. Further, by using the Site, you
              indicate to us that you have read and understand the information
              practices disclosed in our Privacy Policy. You acknowledge and
              agree that these Terms are supported by reasonable and valuable
              consideration (which consideration includes your use of the Site),
              and you acknowledge your receipt of and the sufficiency of the
              consideration. DO NOT USE THE SITE IF YOU DO NOT AGREE WITH EACH
              TERM AND CONDITION IN THESE TERMS.
            </h4>

            <p>
              Majordomo LLC and www.majordomo.com is a Real Estate Software
              Technology software company and website assisting home owners to
              better manage their homes with web-based technologies and
              solutions. Unless you are a professional with a written
              relationship/agreement with Majordomo LLC (a “Professional”), you
              agree to use the services for your personal use only. We reserve
              the right, without notice and for any reason, to remove any
              content from the Site; to modify, suspend, or discontinue the
              Site; and/or to deny access of any user to all or any part of the
              Site.
            </p>

            <h4 className="font-black">Modification of Terms.</h4>

            <p>
              We reserve the right to revise these Terms at any time. We will
              post any new or revised Terms here, and you should review these
              Terms regularly to make sure you are aware of any changes. You can
              determine if these Terms have been revised since the last time you
              accessed the Site by referring to the effective date or last
              updated date at the top of these Terms. If changes are
              significant, we may also notify you of such changes by posting a
              notice on the home page of the Site and/or via contact information
              you have provided to us, if any. Your use of the Site following
              such revision to these Terms constitutes your acceptance of and
              agreement to these Terms, as revised, and the revisions will apply
              to your use of the Site on and after the date on which we post the
              revised Terms.
            </p>

            <h4 className="font-black">Electronic Communications</h4>

            <p>
              Accessing the Site or sending emails to Majordomo constitutes
              electronic communications. You consent to receive electronic
              communications and you agree that all agreements, notices,
              disclosures and other communications that we provide to you
              electronically, via email and on the Site, satisfy any legal
              requirement that such communications be in writing. You agree that
              a printed version of these Terms and of any notice given in
              electronic form shall be admissible in judicial or administrative
              proceedings, based upon or relating to these Terms and/or your use
              of the Services, to the same extent and subject to the same
              conditions as other business documents and records originally
              generated and maintained in printed form. It is the express wish
              to the parties that this agreement and all related documents be
              written in English.
            </p>

            <h4 className="font-black">Your Account</h4>

            <p>
              If you use the Site, you are responsible for maintaining the
              confidentiality of your account and password and for restricting
              access to your computer, and you agree to accept responsibility
              for all activities that occur under your account or password. You
              may not assign or otherwise transfer your account to any other
              person or entity. You acknowledge that Majordomo is not
              responsible for third party access to your account that results
              from theft or misappropriation of your account. Majordomo and its
              associates reserve the right to refuse or cancel service,
              terminate accounts, or remove or edit content in our sole
              discretion. Further, you are responsible for all software,
              hardware, services (such as Internet service), and equipment
              necessary to access and use the Site, including all related
              expenses, if any.
            </p>

            <h4 className="font-black">Children Under Thirteen</h4>

            <p>
              The Site is intended for use by adults only, and Majordomo does
              not knowingly collect, either online or offline, personal
              information from persons under the age of thirteen. If you are
              under 18, you may use the Site only with permission of a parent or
              guardian.
            </p>

            <h4 className="font-black">Cancellation/Refund Policy</h4>

            <p>
              Users can cancel anytime, and there is no charge for free
              accounts. Accounts with paid premium services may cancel as per
              the terms of their premium services agreement agreed upon sign up
              for that service. Professionals will be bound by the terms of
              their membership/advertiser’s user agreement. These Terms will
              continue to apply to all past use of the Site, even if you are no
              longer using the ‎Site, whether voluntarily or because we
              terminated your access thereto.‎
            </p>

            <h4 className="font-black">Links to Third Party Sites</h4>

            <p>
              Third Party Services may contain links to other websites ("Linked
              Sites"). The Linked Sites are not under the control of Majordomo
              and Majordomo is not responsible for the contents of any Linked
              Site, including without limitation any link contained in a Linked
              Site, or any changes or updates to a Linked Site. Majordomo is
              providing these links to you only as a convenience, and the
              inclusion of any link does not imply endorsement by Majordomo of
              the site or any association with its operators.
            </p>

            <p>
              Certain services made available via the Site are delivered by
              third party sites and organizations. By using any product, service
              or functionality originating from the Site domain, you hereby
              acknowledge and consent that Majordomo may share such information
              and data with any third party with whom Majordomo has a
              contractual relationship to provide the requested product, service
              or functionality on behalf of the Site users and customers.
            </p>

            <h4 className="font-black">
              No Unlawful or Prohibited Use/Intellectual Property
            </h4>

            <p>
              You are granted a non-exclusive, non-transferable, revocable
              license to access and use the Site strictly in accordance with
              these terms of use. As a condition of your use of the Site, you
              warrant to Majordomo that you will not use the Site for any
              purpose that is unlawful or prohibited by these Terms. You may not
              use the Site in any manner which could damage, disable,
              overburden, or impair the Site or interfere with any other party's
              use and enjoyment of the Site. You may not obtain or attempt to
              obtain any materials or information through any means not
              intentionally made available or provided for through the Site.
            </p>

            <p>
              Majordomo, and other trademarks, service marks, and names
              appearing on the Site are registered or unregistered trademarks
              and service marks of Majordomo in the United States. Majordomo
              exclusively owns all rights, titles, and interests in and to these
              trademarks, service marks, and names. The display of these marks
              and of notices associated with these marks is not intended to be a
              comprehensive compilation of all of our trademark rights, and we
              may own other trademark rights. All rights not expressly granted
              are reserved. Your use of our trademarks, service marks, and names
              without our prior written consent is strictly prohibited. Without
              limiting the generality of the foregoing, you may not use
              Majordomo’s trademarks, service marks, or names in any meta-tags
              or other hidden text.
            </p>

            <p>
              Product, service, and company names that appear on the Site that
              are not owned by us are subject to trademark and/or other rights
              of other parties.
            </p>

            <p>
              Except for Submissions (as defined below), all content included as
              part of the Site, such as text, graphics, logos, images, and the
              compilation thereof, as well as the selection, arrangement, and
              presentation of all Majordomo content (including information in
              the public domain), and the overall design, “look and feel,” color
              combinations, and other graphical elements of the Site, and any
              software used on the Site, is the property of Majordomo or its
              suppliers and protected by copyright and other laws that protect
              intellectual property and proprietary rights. You agree to observe
              and abide by all copyright and other proprietary notices, legends
              or other restrictions contained in any such content and will not
              make any changes thereto.
            </p>

            <p>
              You will not modify, publish, transmit, reverse engineer,
              participate in the transfer or sale, create derivative works, or
              in any way exploit any of the content, in whole or in part, found
              on the Site. Majordomo content is not for resale. Your use of the
              Site does not entitle you to make any unauthorized use of any
              protected content, and you will not delete or alter any
              proprietary rights or attribution notices in any content. You will
              use protected content solely for your personal use and will make
              no other use of the content without the express written permission
              of Majordomo and the copyright owner. You agree that you do not
              acquire any ownership rights in any protected content. We do not
              grant you any licenses, express or implied, to the intellectual
              property of Majordomo or our licensors except as expressly
              authorized by these Terms.
            </p>

            <p>
              Automated queries including but not limited to screen and database
              scraping, robots, crawlers and any other automated activity with
              the purpose of obtaining information from Majordomo, its users and
              information providers are strictly prohibited unless you have a
              written agreement with Majordomo. Majordomo reserves the right to
              make exceptions for publicly available search engines and other
              Internet navigation tools to the extent such unlicensed "fair use"
              is allowed by applicable copyright laws. Search engines are not
              permitted to query or search information which is protected by a
              security capture system which limits access to human users.
            </p>

            <h4 className="font-black">Use of Communication Services</h4>

            <p>
              The Site may contain bulletin board services, chat areas, news
              groups, forums, communities, personal web pages, calendars,
              Majordomo contacts for access to home service and retail
              professionals, and/or other message or communication facilities
              designed to enable you to communicate with the public at large or
              with a group (collectively, "Communication Services"). You agree
              to use the Communication Services only to post, send and receive
              messages and material that are proper and related to the
              particular Communication Service.
            </p>

            <p>
              By way of example, and not as a limitation, you agree that when
              using a Communication Service, you will not: defame, abuse,
              harass, stalk, threaten or otherwise violate the legal rights
              (such as rights of privacy and publicity) of others; publish,
              post, upload, distribute or disseminate any inappropriate,
              profane, defamatory, infringing, obscene, indecent or unlawful
              topic, name, material or information; upload files that contain
              software or other material protected by intellectual property laws
              (or by rights of privacy of publicity), including home inspection
              reports or similar documentation prepared by a third party, unless
              you own or control the rights thereto or have received all
              necessary consents; upload files that contain viruses, corrupted
              files, or any other similar software or programs that may damage
              the operation of another's computer; advertise or offer to sell or
              buy any goods or services for any business purpose, unless such
              Communication Service specifically allows such messages; conduct
              or forward surveys, contests, pyramid schemes or chain letters;
              download any file posted by another user of a Communication
              Service that you know, or reasonably should know, cannot be
              legally distributed in such manner; falsify or delete any author
              attributions, legal or other proper notices or proprietary
              designations or labels of the origin or source of software or
              other material contained in a file that is uploaded; restrict or
              inhibit any other user from using and enjoying the Communication
              Services; violate any code of conduct or other guidelines which
              may be applicable for any particular Communication Service;
              harvest or otherwise collect information about others, including
              e-mail addresses, without their consent; violate any applicable
              laws or regulations.
            </p>

            <p>
              Majordomo has no obligation to monitor the Communication Services.
              However, Majordomo reserves the right to review materials posted
              to a Communication Service and to remove any materials in its sole
              discretion. Majordomo reserves the right to withdraw your claim of
              ownership to a home if it is deemed you are not the lawful owner
              of a property. Majordomo reserves the right to terminate your
              access to any or all the Communication Services at any time
              without notice for any reason whatsoever.
            </p>

            <p>
              Majordomo reserves the right at all times to disclose any
              information as necessary to satisfy any applicable law,
              regulation, legal process or governmental request, or to edit,
              refuse to post or to remove any information or materials, in whole
              or in part, in Majordomo's sole discretion. Always use caution
              when giving out any personally identifying information about
              yourself, your home or your children in any Communication Service.
              Majordomo does not control or endorse the content, messages or
              information found in any Communication Service and, therefore,
              Majordomo specifically disclaims any liability with regard to the
              Communication Services and any actions resulting from your
              participation in any Communication Service. Managers and hosts are
              not authorized Majordomo spokespersons, and their views do not
              necessarily reflect those of Majordomo.
            </p>

            <p>
              Materials uploaded to a Communication Service may be subject to
              posted limitations on usage, reproduction and/or dissemination.
              You are responsible for adhering to such limitations if you upload
              the materials.
            </p>

            <h4 className="font-black">
              Materials Provided to the Site or Posted on Any Majordomo Web Page
            </h4>

            <p>
              Majordomo does not claim ownership of the materials you provide to
              the Site (including feedback and suggestions) or post, upload,
              input or submit to any Majordomo Site or our associated services
              (collectively "Submissions"). You expressly represent and warrant
              that by posting, uploading, inputting, providing or submitting a
              Submission you own or otherwise control all the rights to your
              Submission as described in this section including, without
              limitation, all the rights necessary for you to provide, post,
              upload, input or submit the Submissions, and that our use of the
              Submission in accordance with these Terms and on or through the
              Site, including to provide any services to you, does not and will
              not infringe, misappropriate, or otherwise violate any third-party
              copyright, trademark, patent, trade secret, or any other
              proprietary right, privacy right, right of publicity, or other
              third-party right. You further agree that by posting, uploading,
              inputting, providing or submitting your Submission you are
              granting Majordomo, our affiliated companies and necessary
              sublicensees a worldwide, nonexclusive, fully paid-up, royalty
              free, perpetual, and irrevocable license to use your Submission in
              connection with the operation of the Site including, without
              limitation, the rights to: record, copy, distribute, transmit,
              publicly display, publicly perform, reproduce, make derivatives
              of, edit, translate and reformat your Submission; and to publish
              your name in connection with your Submission.{' '}
              <span className="font-black">
                You understand and agree that you shall be solely responsible
                and liable for any damages or harm to Majordomo, its officers,
                directors, employees, agents and third parties,‎ resulting from
                your Submissions, and you agree to indemnify us in accordance
                with the Indemnification provision below
              </span>
              . No compensation will be paid with respect to the use of your
              Submission, as provided herein. Majordomo is under no obligation
              to post or use any Submission you may provide and may remove any
              Submission at any time in Majordomo's sole discretion.
            </p>

            <h4 className="font-black">
              Digital Millennium Copyright Act Takedown Notice
            </h4>

            <p>
              We take claims of copyright infringement seriously. We will
              respond to notices of alleged copyright infringement that comply
              with applicable law. If you believe any materials accessible on or
              from the Site infringe your copyright, you may request removal of
              those materials (or access to them) from the Site by submitting
              written notification to hello@majordomo.com. In accordance with
              the Online Copyright Infringement Liability Limitation Act of the
              Digital Millennium Copyright Act (17 U.S.C. § 512) (“DMCA”), the
              written notice (the “DMCA Notice”) must include substantially the
              following:
            </p>

            <p>
              Your physical or electronic signature; Identification of the
              copyrighted work you believe to have been infringed or, if the
              claim involves multiple works on the Site, a representative list
              of such works; Identification of the material you believe to be
              infringing in a sufficiently precise manner to allow us to locate
              that material; Adequate information by which we can contact you
              (including your name, postal address, telephone number, and, if
              available, email address); A statement that you have a good faith
              belief that use of the copyrighted material is not authorized by
              the copyright owner, its agent, or the law; A statement that the
              information in the written notice is accurate; A statement, under
              penalty of perjury, that you are authorized to act on behalf of
              the copyright owner.
            </p>

            <p>
              If you fail to comply with all of the requirements of Section
              512(c)(3) of the DMCA, your DMCA Notice may not be effective.
              <span className="italic underline">
                Please be aware that if you knowingly materially misrepresent
                that material or activity on the Site is infringing your
                copyright, you may be held liable for damages (including costs
                and attorneys' fees) under Section 512(f) of the DMCA
              </span>
              .
            </p>

            <h4 className="font-black">Third Party Accounts</h4>

            <p>
              You may be able to connect your Majordomo account to third party
              accounts. By connecting your Majordomo account to your third-party
              account, you acknowledge and agree that you are consenting to the
              continuous release of information about you to others (in
              accordance with your privacy settings on those third-party sites).
              If you do not want information about you to be shared in this
              manner, do not use this feature. International Users
            </p>

            <p>
              The Service is controlled, operated and administered by Majordomo
              from our offices within the USA. If you access the Service from a
              location outside the USA, you are responsible for compliance with
              all local laws. You agree that you will not use the Majordomo
              Content accessed through the Site in any country or in any manner
              prohibited by any applicable laws, restrictions or regulations.
            </p>

            <h4 className="font-black">Security</h4>

            <p>
              While we try to maintain the security of the Site, we do not
              guarantee that the Site will be secure. Additionally, third
              parties may make unauthorized alterations to the Site. If you
              become aware of any unauthorized third-party alterations to or use
              of the Site or any other breach of security, please contact us
              immediately.
            </p>

            <h4 className="font-black">Indemnification</h4>

            <p>
              You agree to indemnify, defend and hold harmless Majordomo, its
              officers, directors, employees, agents and third parties, for any
              claims, damages, losses, costs, liabilities, judgments, demands,
              awards, and expenses (including reasonable attorney's fees)
              relating to or arising out of your use of or inability to use the
              Site or services or content thereon, any user postings or
              Submissions made by you, your violation of any of these Terms or
              your infringement, misappropriation, or violation of any rights of
              a third party, including any intellectual property rights of any
              third party, or your violation of any applicable laws, rules or
              regulations. Majordomo reserves the right, at its own cost, to
              assume the exclusive defense and control of any matter otherwise
              subject to indemnification by you, in which event you will fully
              cooperate with Majordomo in asserting any available defenses.
            </p>

            <h4 className="font-black">Disputes</h4>

            <p>
              These Terms, and any dispute that may arise between you and
              Majordomo regarding the Site or any ‎ Majordomo content or other
              information or materials on the Site, will be governed by the laws
              of the ‎state of Oregon, USA, without regard to conflict-of-laws
              principles that might result in the application ‎of the laws of
              any other jurisdiction. You hereby consent to the exclusive
              jurisdiction and venue of the ‎federal, state, and local courts
              located in Benton or Lane County, Oregon, and you waive any
              ‎jurisdictional, venue, or inconvenient forum objections thereto.
              You agree that any dispute arising ‎between you and Majordomo
              under these Terms will be conducted only on an individual basis
              and not in a ‎class, consolidated, or representative action. You
              further agree to waive your right to a jury trial in ‎connection
              with any action or litigation arising out of or related to these
              Terms. You further agree that, ‎regardless of any statute or law
              to the contrary, you must file any claim or cause of action
              against ‎ Majordomo arising out of or relating to these Terms or
              your use of the Site within one (1) year after ‎such claim or
              cause of action arose, or forever be barred. It is possible that
              applicable law may not ‎allow for the limitation or waiver of a
              statute of limitations for certain matters. Solely to the extent
              that ‎such law applies to you, the above limitation to when a
              claim or cause of action against Majordomo arising ‎out or related
              to these Terms must be filed may not apply to you. ‎
            </p>

            <p>
              To the extent you have in any manner violated or threatened to
              violate Majordomo’s intellectual property ‎rights; disclosed or
              threatened to disclose any Majordomo confidential or proprietary
              information; violated ‎or threatened to violate the security of
              any person, data, Majordomo servers or networks, and/or the ‎Site;
              and/or otherwise breached or threatened to breach these Terms, you
              acknowledge and ‎agree that such violation or breach will cause
              immediate and irreparable harm to Majordomo, and Majordomo ‎shall
              be entitled to injunctive or other appropriate relief, including
              without limitation specific ‎performance (without the posting of a
              bond or other security and without proving damages), and you
              ‎agree that Majordomo may seek such relief in any court of
              competent jurisdiction.‎
            </p>

            <h4 className="font-black">
              This provision shall survive the termination of these Terms. Class
              Action Waiver
            </h4>

            <p>
              Any dispute resolution under these Terms will take place on an
              individual basis; you expressly acknowledge and agree that
              class/representative/collective actions are not permitted. THE
              PARTIES AGREE THAT A PARTY MAY BRING CLAIMS AGAINST THE OTHER ONLY
              IN EACH'S INDIVIDUAL CAPACITY, AND NOT AS A PLAINTIFF OR CLASS
              MEMBER IN ANY PUTATIVE CLASS, COLLECTIVE AND/ OR REPRESENTATIVE
              PROCEEDING, SUCH AS IN THE FORM OF A PRIVATE ATTORNEY GENERAL
              ACTION AGAINST THE OTHER. Further, unless both you and Majordomo
              agree otherwise, the court may not consolidate more than one
              person's claims and may not otherwise preside over any form of a
              representative or class proceeding.
            </p>

            <h4 className="font-black">No Warranties; Liability Disclaimer</h4>

            <p>
              THE INFORMATION, SOFTWARE, PRODUCTS, AND SERVICES INCLUDED IN OR
              AVAILABLE THROUGH THE SITE MAY INCLUDE INACCURACIES OR
              TYPOGRAPHICAL ERRORS. CHANGES ARE PERIODICALLY ADDED TO THE
              INFORMATION HEREIN. MAJORDOMO LLC AND/OR ITS SUPPLIERS MAY MAKE
              IMPROVEMENTS AND/OR CHANGES IN THE SITE AT ANY TIME. MAJORDOMO LLC
              AND/OR ITS SUPPLIERS, USERS, MEMBERS AND ADVERTISERS MAKE NO
              REPRESENTATIONS ABOUT THE SUITABILITY, RELIABILITY, AVAILABILITY,
              TIMELINESS, AND ACCURACY OF THE INFORMATION, SOFTWARE, PRODUCTS,
              SERVICES AND RELATED GRAPHICS CONTAINED ON THE SITE FOR ANY
              PURPOSE. UNLESS SPECIFICALLY PROVIDED OTHERWISE WITH REGARD TO A
              PARTICULAR MAJORDOMO SERVICE, TO THE MAXIMUM EXTENT PERMITTED BY
              APPLICABLE LAW, ALL SUCH INFORMATION, SOFTWARE, PRODUCTS, SERVICES
              AND RELATED GRAPHICS ARE PROVIDED "AS IS" WITHOUT WARRANTY OR
              CONDITION OF ANY KIND. MAJORDOMO LLC AND/OR ITS SUPPLIERS HEREBY
              DISCLAIM ALL WARRANTIES AND CONDITIONS WITH REGARD TO THIS
              INFORMATION, SOFTWARE, PRODUCTS, SERVICES AND RELATED GRAPHICS,
              INCLUDING ALL IMPLIED WARRANTIES OR CONDITIONS OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE, TITLE AND NON-INFRINGEMENT.
            </p>

            <p>
              IN REGARD TO INFORMATION PROVIDED BY MAJORDOMO, USERS,
              PROFESSIONALS INFORMATION SOURCES ABOUT ANY PROPERTIES OR ANY
              INFORMATION FOUND ON THE SITE OR ANY AFFILIATED WEBSITES; WHILE WE
              WORK DILIGENTLY AND ENCOURAGE ALL INFORMATION SOURCES TO ONLY
              PROVIDE RELIABLE INFORMATION, MAJORDOMO DOES NOT GUARANTEE ANY
              INFORMATION ON THE SITE NOR DOES IT VERIFY THE INFORMATION TO BE
              CORRECT. ANY USER OR PROFESSIONALS UTILIZING THIS INFORMATION TO
              MAKE ANY DECISIONS SHOULD HAVE ANY AND ALL INFORMATION
              INDEPENDENTLY VERIFIED TO THEIR SATISFACTION. USERS AGREE TO
              REPORT ANY MIS-INFORMATION SUBMITTED OR FOUND TO MAJORDOMO.
            </p>

            <p>
              MAJORDOMO IS NOT A LICENSED REAL ESTATE BROKER AGENCY, OR LENDER,
              NOR IS IT A LICENSED CONTRACTOR/HOME INSPECTOR AND MAKES NO
              REPRESENTATIONS THEREOF. ALL INFORMATION PROVIDED IS TO ASSIST
              SITE USERS IN THEIR DECISION MAKING REGARDING THEIR HOMES AND
              BUSINESSES. FOR THE AVOIDANCE OF DOUBT, MAJORDOMO DOES NOT ASSIST,
              NEGOTIATE, SUPPORT, NOR IS IT IN ANY WAY INVOLVED, IN REAL ESTATE
              TRANSACTIONS AS A REPRESENTATIVE OR AGENT OF ANY BUYERS, SELLERS,
              AGENTS OR LENDERS, NOR DOES IT REPRESENT OR ENDORSE ANY REAL
              ESTATE AGENTS OR LENDERS, AND AS SUCH YOU ACKNOWLEDGE AND AGREE
              THAT IN NO EVENT WILL MAJORDOMO BE RESPONSIBLE FOR ANY ACTS,
              OMISSIONS, OR FAILURES OF ANY DUTY OR OBLIGATION BY ANY BUYERS,
              SELLERS, AGENTS, OR LENDERS THAT ARE PARTY TO A REAL ESTATE
              TRANSACTION.
            </p>

            <p>
              MAJORDOMO MAY PROVIDE PROFESSIONAL CONNECTIONS AND SERVICES TO
              ASSIST HOMEOWNERS TO FIND HOME PROFESSIONALS, PRODUCTS, RETAILERS
              AND LIKE SERVICES. MAJORDOMO DOES NOT GUARANTY THE INFORMATION
              PROVIDED, NOR THE SERVICES OF THE PROFESSIONALS. YOU, AS THE USER,
              UNDERSTAND IT IS YOUR RESPONSIBILITY TO VERIFY ALL INFORMATION
              REGARDING SERVICE PROFESSIONALS, THEIR BIDS & ESTIMATES/QUOTES AND
              HIRING SERVICE PROFESSIONALS. ANY AND ALL WORK AGREEMENTS ARE
              BETWEEN YOU, THE USER AND THE PROFESSIONAL ONLY AND DOES NOT
              INCLUDE MAJORDOMO.
            </p>

            <p>
              MAJORDOMO DOMOSCORE IS AN AUTOMATED HOME SCORING PRODUCT/SYSTEM
              PROVIDED TO HELP BETTER UNDERSTAND THE OVERALL CONDITION AND
              SYSTEMS OF A PROPERTY. MAJORDOMO DOES NOT GUARANTEE THE
              INFORMATION OR RECOMMENDATIONS TO BE CORRECT AND THE USER IS
              ENCOURAGED TO VERIFY ALL QUESTIONS TO THEIR SATISFACTION PRIOR TO
              MAKING ANY DECISIONS BASED ON THE RESULTS. USE OF DOMOSCORE IS NOT
              ALLOWED FOR COMMERCIAL USE OR RESALE WITHOUT PRIOR WRITTEN
              AGREEMENT FROM MAJORDOMO.
            </p>

            <p>
              MAJORDOMO DOMOREPORT IS A 3RD PARTY REVIEW/SUMMARY OF A PROPERTY’S
              INFORMATION/INSPECTION BASED UPON THE HOME INSPECTION PROVIDED TO
              MAJORDOMO BY THE USER FOR ESTIMATING AND NEGOTIATIONS. THE
              DOMOREPORT MAY INCLUDE ESTIMATES AND DESCRIBED SOLUTIONS FOR
              REPAIRS BASED UPON THE HOME INSPECTION PROVIDED BY THE USER. THESE
              ESTIMATES AND SOLUTIONS ARE NOT TO BE DEEMED ACTUAL CONTRACTOR
              QUOTES FOR THE SPECIFIC ADDRESS. VERIFYING ACTUAL QUOTES AND
              SOLUTIONS WITH LOCAL CONTRACTORS IS RECOMMENDED. ACTUAL COSTS FOR
              THE REPAIRS MAY BE HIGHER, OR LOWER. OUR ESTIMATES ARE BASED ON
              RESEARCHED COSTS FOR SIMILAR REPAIRS IN YOUR AREA. WHILE MAJORDOMO
              MAKES DILIGENT EFFORTS TO INCLUDE ALL REPAIRS AND DETAILS FROM THE
              USER AS SPECIFIED IN THE PRODUCT FEATURES DESCRIPTION – IT IS NOT
              GUARANTEED. A USER SHOULD VERIFY ALL INFORMATION INCLUDED IN THE
              DOMOREPORT TO THEIR SATISFACTION BEFORE RELYING UPON IT FOR ANY
              REASON. THE DOMOREPORT MAY INCLUDE RECOMMENDATIONS FOR SERVICES OR
              PRODUCTS. USERS SHOULD RESEARCH AND VERIFY ALL ASPECTS OF THESE
              RECOMMENDATIONS TO THEIR SATISFACTION PRIOR TO TAKING ANY ACTION.
            </p>

            <p>
              MAJORDOMO EXPLORE RESOURCES ARE PROVIDED TO HELP USERS AS THEY
              RESEARCH PROPERTIES. RESOURCES ARE UNVERIFIED 3RD PARTY
              INFORMATION PROVIDERS. A USER SHOULD VERIFY ALL INFORMATION
              INCLUDED IN THE RESOURCES/3RD PARTY INFORMATION TO THEIR
              SATISFACTION BEFORE RELYING UPON IT FOR ANY REASON.
            </p>

            <p>
              MAJORDOMO DOCUMENTS IS A SERVICE PROVIDED FOR USERS TO STORE
              PERSONAL DOCUMENTS WITHIN MAJORDOMO’S SYSTEMS. USE OF DOCUMENTS IS
              AT THE USER’S RISK. USER IS RESPONSIBLE FOR ADDING, REMOVING OR
              SHARING DOCUMENTS AT THEIR DISCRETION.
            </p>

            <p>
              BY AGREEING TO THESE TERMS YOU ARE INDICATING YOU HAVE REVIEWED
              MAJORDOMOS RECOMMENDATIONS FOR HIRING CONTRACTORS, AND HAVE
              VERIFIED ALL INFORMATION TO YOUR SATISFACTION. IN ADDITION, YOU
              HAVE REVIEWED AND AGREE TO THE END USER LICENSE AGREEMENT (“EULA”)
              FROM MAJORDOMO SERVICE/INFORMATION PROVIDERS INDICATED IN THIS
              AGREEMENT.
            </p>

            <p>
              <a
                className="text-accentBlue font-black hover:underline"
                href="http://help.majordomo.com/en/articles/3300612-what-should-i-know-about-researching-contractors-quick-tips"
                target="_blank"
                rel="noopener noreferrer"
              >
                QUICK TIPS FOR HIRING HOME PROFESSIONALS
              </a>
            </p>
            <p>
              <a
                className="text-accentBlue font-black hover:underline"
                href="http://help.majordomo.com/en/articles/3300628-hiring-home-professionals-and-contractor-research-tips"
                target="_blank"
                rel="noopener noreferrer"
              >
                INFORMATION ABOUT HIRING HOME PROFESSIONALS
              </a>
            </p>

            <p>
              This Program/documentation is proprietary to Majordomo LLC and
              Xactware Solutions, Inc and may not be used or copied without its
              prior written consent
            </p>

            <p>
              <a
                className="text-accentBlue font-black hover:underline"
                href="https://www.estimateon.com/assets/EstimateOn%20EULA%20LSG%20102218%20v2.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.estimateon.com/assets/EstimateOn%20EULA%20LSG%20102218%20v2.pdf
              </a>
            </p>

            <p>
              TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT
              SHALL MAJORDOMO AND/OR ITS SUPPLIERS BE LIABLE FOR ANY DIRECT,
              INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL, CONSEQUENTIAL DAMAGES OR
              ANY DAMAGES WHATSOEVER INCLUDING, WITHOUT LIMITATION, DAMAGES FOR
              LOSS OF USE, DATA OR PROFITS, ARISING OUT OF OR IN ANY WAY
              CONNECTED WITH THE USE OR PERFORMANCE OF THE SITE, WITH THE DELAY
              OR INABILITY TO USE THE SITE OR RELATED SERVICES, THE PROVISION OF
              OR FAILURE TO PROVIDE SERVICES, OR FOR ANY INFORMATION, SOFTWARE,
              PRODUCTS, SERVICES AND RELATED GRAPHICS OBTAINED THROUGH THE SITE,
              OR OTHERWISE ARISING OUT OF THE USE OF THE SITE, WHETHER BASED ON
              CONTRACT, TORT, NEGLIGENCE, STRICT LIABILITY OR OTHERWISE, EVEN IF
              MAJORDOMO OR ANY OF ITS SUPPLIERS HAS BEEN ADVISED OF THE
              POSSIBILITY OF DAMAGES. NOTWITHSTANDING THE FOREGOING, IN ALL
              CIRCUMSTANCES, MAJORDOMO’S MAXIMUM AGGREGATE LIABILITY FOR ALL
              DAMAGES, LOSSES, AND CLAIMS, WHETHER IN CONTRACT, TORT (INCLUDING
              WITHOUT LIMITATION NEGLIGENCE), OR OTHERWISE SHALL NOT EXCEED THE
              ACTUAL AMOUNT OF FEES PAID TO MAJORDOMO FOR THE SERVICE IN TWELVE
              (12) MONTHS IMMEDIATELY PROCEEDING THE EVENT GIVING RISE TO
              DAMAGES. BECAUSE SOME STATES/JURISDICTIONS DO NOT ALLOW THE
              EXCLUSION OR LIMITATION OF LIABILITY FOR CONSEQUENTIAL OR
              INCIDENTAL DAMAGES, OR IF APPLICABLE LAW PROHIBITS THE LIMITATION
              OR EXCLUSION OF A PARTY’S LIABILITY WITH RESPECT TO DEATH OR
              PERSONAL INJURY CAUSED BY SUCH PARTY’S NEGLIGENCE, FRAUD, OR ANY
              OTHER MATTER, THEN SUCH PARTY’S LIABILITY WILL NOT BE LIMITED OR
              EXCLUDED TO THE EXTENT OF SUCH PROHIBITION UNDER SUCH APPLICABLE
              LAW. IF YOU ARE DISSATISFIED WITH ANY PORTION OF THE SITE, OR WITH
              ANY OF THESE TERMS OF USE, YOUR SOLE AND EXCLUSIVE REMEDY IS TO
              DISCONTINUE USING THE SITE.
            </p>

            <h4 className="font-black">
              Discontinuance and Modification; Termination/Access Restriction
            </h4>

            <p>
              There is no guarantee that we will continue to offer or provide
              the Services, and we may simply suspend or discontinue the
              Services (or any part thereof) at any time for any reason and
              without notice to you. We have the right to remove any content
              from the Services or to modify the Services. Except as otherwise
              may be provided in your services Agreement, Majordomo reserves the
              right, in its sole discretion, to terminate your access to the
              Site and the related services or any portion thereof at any time,
              without notice. To the maximum extent permitted by law, this
              agreement is governed by the laws of the State of Oregon. Use of
              the Site is unauthorized in any jurisdiction that does not give
              effect to all provisions of these Terms, including, without
              limitation, this section.
            </p>

            <h4 className="font-black">General</h4>

            <p>
              You agree that no joint venture, partnership, employment, or
              agency relationship exists between you and Majordomo as a result
              of this agreement or use of the Site. Majordomo's performance of
              this agreement is subject to existing laws and legal process, and
              nothing contained in this agreement is in derogation of
              Majordomo's right to comply with governmental, court and law
              enforcement requests or requirements relating to your use of the
              Site or information provided to or gathered by Majordomo with
              respect to such use. If any part of this agreement is determined
              to be invalid or unenforceable pursuant to applicable law
              including, but not limited to, the warranty disclaimers and
              liability limitations set forth above, then the invalid or
              unenforceable provision will be deemed superseded by a valid,
              enforceable provision that most closely matches the intent of the
              original provision and the remainder of the agreement shall
              continue in effect.
            </p>

            <p>
              Unless otherwise specified herein, this agreement constitutes the
              entire agreement between the user and Majordomo with respect to
              the Site and it supersedes all prior or contemporaneous
              communications and proposals, whether electronic, oral or written,
              between the user and Majordomo with respect to the Site.
            </p>

            <h4 className="font-black">Contact Us</h4>
            <p>
              Majordomo welcomes your questions or comments regarding the Terms:
            </p>
            <p>
              Majordomo LLC
              <br />
              5060 SW Philomath Blvd. Box 169
              <br />
              Corvallis, Oregon 97333 <br />
              Email Address:{' '}
              <a
                className="text-accentBlue font-black hover:underline"
                href="mailto:hello@majordomo.com"
              >
                hello@majordomo.com
              </a>
            </p>

            <p>Revised and Effective as of March 23, 2021</p>
          </div>
        </div>
      </main>

      <Footer />
    </>
  )
}
